import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { GiftCardDto, Transaction } from "src/app/shared/models/DTO/gift-card.dto";

@Component({
	selector: "app-gift-card-dashboard",
	templateUrl: "./gift-card-dashboard.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class GiftCardDashboardComponent implements OnInit {
	@Input() cards: GiftCardDto[];
	@Output() cardsChange = new EventEmitter<GiftCardDto[]>();

	outstandingBalance: number;

	lastTransaction: Transaction;
	cardCount: number = 0;
	constructor(public app: AppService, public venueService: OOVenueService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.getBalanceSheet();
		this.giftActivity();
	}

	async giftActivity() {
		const resp = await this.focuslink.giftCardActivity(this.venueService.subscriptionVenue.value.key);
		this.outstandingBalance = resp.balance;
		this.lastTransaction = new Transaction(resp.lastTransaction);

		this.cardCount = resp.count;
	}

	async getBalanceSheet() {
		const endDate = this.app.moment().format("YYYY-MM-DD");
		const resp = await this.focuslink.giftCardBalanceSheet(this.venueService.subscriptionVenue.value.key, endDate);
		this.outstandingBalance = resp.balance;
	}
}
